export default "__VITE_ASSET__d81ebf51__"